<template>
    <div>
        <v-divider class="mt-1 mb-3" />
        <div class="v-flex">
            <div class="editor-title primary white--text v-flex mr-1" style="z-index: 1">
                <div>{{ title }}</div>
                <v-spacer />
                <div
                    class="v-flex"
                    style="margin-top: -5px"
                >
                    <c-toolbar-button
                        v-if     = "!readonly"
                        class    = "mr-0"
                        color    = "white"
                        icon     = "mdi-content-save"
                        size     = "18"
                        :tooltip = "$t('contract.edit.store')"
                        @click   = "onStore"
                    />
                    <c-toolbar-button
                        class    = "mr-0"
                        color    = "white"
                        :icon    = "readonly ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        size     = "18"
                        :tooltip = "readonly ? $t('contract.edit.off') : $t('contract.edit.on')"
                        @click   = "onEdit"
                    />
                </div>
            </div>
            <div style="margin-top: -2px" v-if="terminate">
                <div v-if="readonly && unitData.terminate" style="font-size: 13px; padding-top: 2px" class="error--text pl-1">
                    Vertrag wird beendet
                </div>
                <v-checkbox
                    v-if="!readonly"
                    class="mt-0 pt-0"
                    v-model="unitData.terminate"
                    :ripple="false"
                    label="Vertrag beenden"
                    hide-details
                />
            </div>
        </div>
        <div class="pl-2 pr-2 pb-3 lm-border edit-area" style="margin-top: -1px; z-index: 1">
            <v-row class="no-frame">

                <v-col class="no-frame v-flex col-6 pr-1">
                    <f-read-only-field
                        v-if   = "readonly"
                        class  = "w-100 mt-1"
                        :dense = "true"
                        :label = "$t('contract.start')"
                        :value = "dateAsString(start)"
                        color  = "pt-0-5 pl-1 ro-background"
                    />

                    <f-date-picker
                        v-if          = "!readonly"
                        v-model       = "start"
                        label         = "contract.start"
                        :hide-details = "true"
                        @change       = "onStart"
                    />
                </v-col>
                <v-col class="no-frame pl-1 col-6">
                    <f-read-only-field
                        v-if   = "readonly"
                        class  = "w-100 mt-1"
                        :dense = "true"
                        :label = "$t('contract.expiration')"
                        :value = "dateAsString(end)"
                        color  = "pt-0-5 pl-1 ro-background"
                    />

                    <f-date-picker
                        v-if          = "!readonly"
                        v-model       = "end"
                        label         = "contract.expiration"
                        :hide-details = "true"
                        @change       = "onEnd"
                    />
                </v-col>
            </v-row>
            <slot name="additional"  />
        </div>
    </div>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import FDatePicker    from "@/modules/core/components/utils/FDatePicker";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";

export default {
    name: "CContractEditor",

    components: {
        FReadOnlyField,
        CToolbarButton,
        FDatePicker
    },

    props: {
        title: {

        },

        unitData: {

        },

        terminate: {

        }
    },

    data: () => ({
        readonly: true,
        start   : null,
        end     : null
    }),

    mounted() {
        this.setData();
    },

    watch: {
        unitData () {
            this.setData();
        }
    },

    methods: {
        onStore () {
            this.$emit ("store")
        },

        onEdit () {
            this.readonly = !this.readonly;
            this.$emit ("edit", this.readonly)
        },

        onStart () {
            this.$emit("start", this.start);
        },

        onEnd () {
            this.$emit("end", this.end);
        },

        setData () {
            if (!this.unitData) {
                return;
            }

            this.$nextTick(() => {
                this.start = this.unitData.start;
                this.end   = this.unitData.end;
            })
        },

        dateAsString (value) {
            return Core.format.date.display(value);
        },
    }
}
</script>

<style scoped>

.edit-area {
    background-color: white;
    border-top-left-radius: unset!important;
}

.editor-title {
    font-size: 13px;
    width: calc(50% - 4px);
    padding-left: 8px;
    padding-top: 2px;
    max-height: 24px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    position: relative;
}

::v-deep .toolbar-button {
    padding: 4px;
}

::v-deep .v-input input {
    font-size: 13px;
}

::v-deep .theme--light.v-label {
    font-size: 13px;
}

::v-deep .v-label--active {
    font-size: 15px!important;
}

::v-deep .readonly-value {
    font-size: 13px;
    min-height: 26px;
}

::v-deep .v-input--selection-controls__input {
    margin-right: 0px;
}

</style>